import React from 'react';
import CONSTANTS from '../../assets/constants';

const Footer = () => (
  <div className="primary-background padding-vertical-3">
    <div className="grid-container">
      <div className="white-color text-left">
        {CONSTANTS.FOOTER_INSTRUCTIONS}
      </div>
      <div className="white-color text-left">
        {CONSTANTS.FOOTER_INSTRUCTIONS2}
      </div>
      <div className="white-color text-left">
        {CONSTANTS.FOOTER_INSTRUCTIONS3}
      </div>
    </div>
  </div>
);

export default Footer;
